import { useQuery } from '@tanstack/react-query';
import { fetchStaffInfo } from '../../api/staff.ts';
import type { Staff } from '../../models/staff.ts';

export default function useStaffInfo() {
  const response = useQuery<{ data: Staff }>({
    queryKey: ['staff', 'info'],
    queryFn: () => fetchStaffInfo(),
  });
  const { data, ...rest } = response;
  return { staff: data?.data, ...rest };
}


